// client\src\services\courseService.js
import apiClient from "../utils/apiClient";

// Get course details by slug
export const getCourseBySlug = async (slug) => {
    try {
        const response = await apiClient.get(`/course/${slug}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching course details:", error);
        throw error;
    }
};

// Check enrollment status for a course
export const checkEnrollmentStatus = async (courseId) => {
    try {
        const response = await apiClient.post(`/course/status`, { courseId });
        // console.error("Response Data", response.data.data);
        return response.data.data;
    } catch (error) {
        console.error("Error checking enrollment status:", error);
        throw error;
    }
};

// Enroll in course
export const enrollInCourse = async (courseId, inviteCode = null) => {
    try {
        const response = await apiClient.post(`/course/enroll`, {
            courseId,
            accessCode: inviteCode
        });
        return response.data;
    } catch (error) {
        console.error("Error enrolling in course:", error);
        throw error;
    }
};